// removed by extract-text-webpack-plugin
module.exports = {"price-input":"style__price-input___h3KXw","percentage-input":"style__percentage-input___B4-OH","fixed_value":"style__fixed_value___Gm71O","fixed_percentage":"style__fixed_percentage___2dSFi"};


//////////////////
// WEBPACK FOOTER
// ./components/PromotionValueInput/style.scss
// module id = 1391
// module chunks = 0